import type {EligibilityReason} from './controlState';

export interface TaskEligibilityInput {
	readOnly: {isReadOnly: boolean} | null;
}

// Only task_locked is derivable today. role / no_agent_for_role / no_genai_access need
// permission data no surface currently fetches — they default to eligible until a later
// ticket wires them.
export function deriveEligibilityFromTask(task: TaskEligibilityInput): EligibilityReason | null {
	if (task.readOnly?.isReadOnly) return 'task_locked';
	return null;
}
